import { useState } from "react";
import {
  ButtonEnter,
  ButtonRegister,
  Content,
  ForgotPasswordLinkContainer,
  LinhaVertical,
  Space,
  TitleButtonEnter,
  TitleButtonRegister,
  TitleInput,
  Title,
  ErrorText,
  MarginBottom,
  Column,
  Img,
  DivImg,
} from "./style";
import Navbar from "../../../components/navbar/navbar";
import Footer from "../../../components/footer/footer";
import { ContainerMargin } from "../../cart/style";
import { MdOutlineEmail } from "react-icons/md";
import { RiEyeLine, RiEyeOffLine, RiLockPasswordLine } from "react-icons/ri";
import InputWithIcon from "../../../components/input/input";
import logo from "../../../assets/images/new-logo.png";
import {
  Formik,
  Field,
  Form,
  FormikHelpers,
  FieldInputProps,
  ErrorMessage,
} from "formik";
import { Center } from "@chakra-ui/react";

import authValidation from "../../../utils/validation/authValidation";
import { ToastContainer } from "react-toastify";
import { useAuth } from "../../../context/AuthContext";
import { BeatLoader } from "react-spinners";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function LoginSeller() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const initialValues = {
    email: "",
    password: "",
    user_type: "buyer",
  };
  const handleRegister = () => {
    navigate("/registerBuy");
  };

  const handleSubmit = async (
    values: typeof initialValues,
    actions: FormikHelpers<typeof initialValues>
  ) => {
    try {
      setIsLoading(true);
      login(values);
      setIsLoading(false);
    } catch (error) {
      console.error("Login error:", (error as Error).message);
    }
  };
  return (
    <>
      <div className="p-16 flex justify-center items-center bg-[url('/background-comprador.png')] bg-cover bg-no-repeat min-h-screen">
        <div className="w-full flex items-center justify-evenly gap-30">
          <div className="flex justify-center flex-col items-center w-[50%]">
            <DivImg>
              <Img src={logo} alt="Ecolife" />
            </DivImg>
          </div>
          <Space>
            <div
              className="
                rounded-2xl
                backdrop-blur-sm bg-white/60
                !shadow-2xl 
            "
            >
              <h1 className="text-center text-black !text-4xl !font-medium pt-10">
                {t("buy-title")}
              </h1>
              <div className="p-7">
                <Formik
                  validationSchema={authValidation}
                  initialValues={initialValues}
                  onSubmit={handleSubmit}
                >
                  <Form>
                    <TitleInput>{t("email")}</TitleInput>
                    <Field
                      type="text"
                      name="email"
                      render={({ field }: { field?: FieldInputProps<any> }) => (
                        <InputWithIcon
                          icon={<MdOutlineEmail />}
                          iconSize="23px"
                          field={field}
                          placeholder={t("type-email")}
                        />
                      )}
                    />
                    <ErrorText>
                      <ErrorMessage name="email" />
                    </ErrorText>
                    <MarginBottom />
                    <TitleInput>{t("password")}</TitleInput>
                    <Field
                      name="password"
                      render={({ field }: { field: FieldInputProps<any> }) => (
                        <InputWithIcon
                          icon={<RiLockPasswordLine />}
                          iconSize="23px"
                          field={field}
                          type={showPassword ? "text" : "password"}
                          placeholder={t("type-password")}
                          rightIcon={
                            // Suporte opcional no seu InputWithIcon
                            <button
                              type="button"
                              onClick={() => setShowPassword((prev) => !prev)}
                              className="text-gray-600"
                            >
                              {showPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                            </button>
                          }
                        />
                      )}
                    />
                    <ErrorText>
                      <ErrorMessage name="password" />
                    </ErrorText>

                    <MarginBottom />

                    <Column>
                      <ForgotPasswordLinkContainer
                        onClick={() => navigate("/forgetPassword")}
                      >
                        {t("remember")}
                      </ForgotPasswordLinkContainer>
                    </Column>
                    <Center>
                      <button
                        className="h-11 w-[350px] !mb-5 !bg-[#658C39] rounded-lg"
                        type="submit"
                      >
                        {isLoading ? (
                          <BeatLoader
                            className="spinner"
                            size={8}
                            color={"#fff"}
                          />
                        ) : (
                          <TitleButtonEnter>{t("login")}</TitleButtonEnter>
                        )}
                      </button>
                    </Center>
                    <Center>
                      <button className="h-[45px] left-0 top-0 w-[350px] !mb-5 justify-center items-center !border-[2px] !border-[#50700f] !rounded-lg" onClick={handleRegister}>
                        <TitleButtonRegister>
                          {t("new-account")}
                        </TitleButtonRegister>
                      </button>
                    </Center>
                  </Form>
                </Formik>
              </div>
            </div>
          </Space>
        </div>
        <ToastContainer />
      </div>
      <Footer />
    </>
  );
}
